import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import classNames from 'classnames';
import { forwardRef } from 'react';
const locale = () => {
  switch (I18n.locale) {
    case 'en':
      return 'en-us';
    case 'pt':
      return 'pt-br';
    default:
      return I18n.locale;
  }
};
const helpCenterLinkCss = "h1h9m7je";
export const HelpCenterLink = forwardRef((props, ref) => {
  const as = 'a';
  const href = `https://help.calendly.com/hc/${locale()}/articles/28424353232663`;
  const target = '_blank';
  const rel = 'noopener noreferrer';
  return <BareButton ref={ref} {...props} as={as} href={href} target={target} rel={rel} className={classNames(helpCenterLinkCss, props.className)} />;
});

require("./help_center_link.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./help_center_link.js");